import { Box, Container } from '@mui/material'
import React from 'react'

const CenteredContainer = ({ sx, children, ...rest }) => {
  return (
    <Container
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100%',
        ...sx,
      }}
      {...rest}
    >
      <Box width='100%'>{children}</Box>
    </Container>
  )
}

export default CenteredContainer
